import { Answers } from '../types';

export const fillWithAnswers = (takenAnswers: Answers[], userChosenAnswer: Answers[]) => {
  return takenAnswers.map((answer: any) => {
    const foundAnswer = userChosenAnswer.filter(Boolean).find(el => el.questionId === answer.questionId);
    return foundAnswer || answer;
  });
};
